import { render } from "./TabUpload.vue?vue&type=template&id=1d794f90"
import script from "./TabUpload.vue?vue&type=script&lang=js"
export * from "./TabUpload.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__